import { SensorReadDto } from '../_generated/api/tagged-hardware'
import ApiLifeCycleModel from './ApiLifeCycleModel'
import TraceabilityTag from './TraceabilityTag'

export default class Sensor extends ApiLifeCycleModel<SensorReadDto> {
    get id() {
        return this.data.id ?? ''
    }

    get serialNo() {
        return this.data.serialNo ?? ''
    }

    get timesUsed() {
        return this.data.numberOfMeasurementsUsed ?? 0
    }

    get size() {
        return this.data.size ?? undefined
    }

    get frequency() {
        return this.data.frequency ?? undefined
    }

    get currentTag() {
        return TraceabilityTag.nullable(this.data.currentTag)
    }

    get previousTags() {
        return this.data.previousTags?.map((t) => new TraceabilityTag(t)) ?? []
    }
}
